type ClassValue = string | number | undefined | null | boolean | ClassValue[];

/**
 * Simple utility to conditionally join class names
 * Similar to clsx but without the dependency
 */
export function cn(...inputs: ClassValue[]): string {
  return inputs
    .flat()
    .filter((x): x is string => typeof x === 'string' && x.length > 0)
    .join(' ');
}
